import { all } from "redux-saga/effects";
import {
  livePropertyListWatcher,
  propertyRequestWatcher,
} from "../../property-saga/property-request-saga";

export default function* propertyRequestRootSaga() {
  yield all([propertyRequestWatcher(), livePropertyListWatcher()]);
}
